import { createSlice } from "@reduxjs/toolkit";

export interface DeepViewSlice {
  deepViewData: any;
  deepViewLoading: boolean;
  fetchedForKey: string | null;
  currencyData: any;
}

const initialState: DeepViewSlice = {
  deepViewData: null,
  deepViewLoading: false,
  fetchedForKey: null,
  currencyData: null,
};

const deepViewSlice = createSlice({
  name: "deepView",
  initialState,
  reducers: {
    setDeepViewData: (state, action) => {
      state.deepViewData = action.payload;
    },
    setDeepViewLoading: (state, action) => {
      state.deepViewLoading = action.payload;
    },
    setDeepViewFetchedForKey: (state, action) => {
      state.fetchedForKey = action.payload;
    },
    setCurrencyData: (state, action) => {
      state.currencyData = action.payload;
    },
    clearDeepView: () => initialState,
  },
});

export const {
  setDeepViewData,
  setDeepViewLoading,
  setDeepViewFetchedForKey,
  clearDeepView,
  setCurrencyData,
} = deepViewSlice.actions;

export const selectDeepViewLoading = (state: any) =>
  state?.deepView?.deepViewLoading;

export const selectCurrencyData = (state: any) => state?.deepView?.currencyData;

export default deepViewSlice.reducer;
